import { ModelPath, PathTokens } from "./ModelPath";

export interface ModelPathValidationResult {
    readonly valid: boolean;
    readonly invalidToken?: string;
    readonly error?: string;
}

export class ModelPathValidator {
    private static readonly NAME_START_CHAR =
        "[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF" +
        "\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F" +
        "\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]";

    private static readonly NAME_CHAR =
        "[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF" +
        "\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F" +
        "\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD" +
        "\\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]";

    // Full XML Name regex built from the two character classes above.
    // The `u` flag enables proper handling of Unicode code points > U+FFFF.
    private static readonly XML_NAME_REGEX = new RegExp(
        `^${ModelPathValidator.NAME_START_CHAR}${ModelPathValidator.NAME_CHAR}*$`,
        "u"
    );

    public static validate(path: ModelPath): ModelPathValidationResult {
        for (const token of path.getPathParts()) {
            if (PathTokens.isMultiToken(token)) {
                continue;
            }

            if (PathTokens.isInstanceTokenOrInstancesSpec(token)) {
                continue;
            }

            if (token === "." || token === "..") {
                continue;
            }

            if (!ModelPathValidator.isValidXmlName(token)) {
                return {
                    valid: false,
                    invalidToken: token,
                    error: `Token "${token}" is not a valid XML name`,
                };
            }
        }

        return { valid: true };
    }

    public static isValidXmlName(name: string): boolean {
        return ModelPathValidator.XML_NAME_REGEX.test(name);
    }
}
